<template>	
	<div class="container-fluid px-lg-2 px-xl-4">
		<pm-pop-up v-if="mostrarPopUp"></pm-pop-up>
		<div class="row no-gutters">
			<div class="col-12 my-1 col-lg-12 px-lg-1">
				<pm-banners :items="tipo1" @clickItem="moverUrl"></pm-banners>
			</div>
			<div class="col-12 my-1 col-lg-6 px-lg-1">
				<pm-banners :items="tipo2" @clickItem="moverUrl"></pm-banners>
			</div>
			<div class="col-12 my-1 col-lg-6 px-lg-1">
				<pm-banners :items="tipo3" @clickItem="moverUrl"></pm-banners>
			</div>
			<div class="col-12 my-1 col-lg-4 px-lg-1">
				<pm-banners :items="tipo4" @clickItem="moverUrl"></pm-banners>
			</div>
			<div class="col-12 my-1 col-lg-4 px-lg-1">
				<pm-banners :items="tipo5" @clickItem="moverUrl"></pm-banners>
			</div>
			<div class="col-12 my-1 col-lg-4 px-lg-1">
				<pm-banners v-if="tipo6.length > 0" :items="tipo6" @clickItem="moverUrl"></pm-banners>				
			</div>
		</div>
	</div>
</template>

<script>
	import PmPopUp from '@/components/clientes/PopUp'
	import PmBanners from "@/components/clientes/Banners"
	import servicio from "@/services/servicio-inicio"

	//import servicioParametros from '@/services/servicio-parametros'
	import servicioCarrito from '@/services/servicio-carrito'

	export default {
		data() {
			return {
				items: [],
				ImagenPublicidad: '',
				itemsLogos: [],
				totalCarouselItems:[],
				mostrarPopUp: false,
				CadenaRelacionados: '',
				TienesRelacionados:  false
			}
		},
		async mounted() {	

			if (localStorage.getItem('mostrarPopUp') === 'true') {

				this.mostrarPopUp = true;
				localStorage.setItem('mostrarPopUp', 'false');

			} else {

				this.mostrarPopUp = false;
			}
			
			await servicioCarrito.migrarArticulosCarritoViejaNueva()
				.then( r => {
					if(r.value){
						this.carritoConsultarCantidad()
					}
					else{
						console.log('migrarArticulosCarritoViejaNueva', r.message)
					}
				})
				.catch ( error => {
					console.log('migrarArticulosCarritoViejaNueva=>', error)
				})
			// servicioParametros.parametro('WebNueva')
			// .then(r=> {								
			// 	//console.log(r, window.localStorage.token)
			// 	if(r.value == 'false'){										
			// 		window.location.href = 'https://www.difarmer.com/alpha/VerifyClient.aspx?tid=' + window.localStorage.token + '&rtid=' + window.localStorage.refreshToken + '&rurl=https://www.difarmer.com/alpha/Clientes/Default.aspx'
			// 	}
			// })

			//console.log(this.$route.path)
			//console.log(process.env.BASE_URL)			
			servicio
				.getBanners(0, true)
				.then(r => {
					this.items = r.data
				})
				.catch(err => {
					console.error(err)
				})
			
			this.nuevosConsultarCantidad()
			this.ofertasConsultarCantidad()
			this.rematesConsultarCantidad()
			this.obtenerNotificaciones()
		},
		components: {
			PmBanners,
			PmPopUp
		},
		methods: {
			consultarBannersComerciales(){
            servicio.consultarBannerComercialLogo()
				.then((response => {
					
					if(response.value){
						this.itemsLogos = response.data
						this.cargarItemsCarousel()
					}
				}) )
				.catch(error => {
					console.error(error);
				})
			},
			cargarItemsCarousel(){
				let logosPorSlide = 12
				this.totalCarousel = Math.ceil(this.itemsLogos.length/logosPorSlide)
				this.totalCarouselItems = []

				for (var i = 0; i < this.totalCarousel; i++) {
					let datos = {}
					
					if( i == 0){
						datos.data =  this.itemsLogos.filter((dato, index) => index < logosPorSlide)
					}
					else if(((i) * logosPorSlide) < this.itemsLogos.length) {
						datos.data =  this.itemsLogos.filter((dato, index) => index >= logosPorSlide && index < ((i + 1) * logosPorSlide))
					}

					datos.item = i
					this.totalCarouselItems.push(datos)
				}

			},
			async moverUrl(item) {	

				this.registrarClickPublicidad(item)

				await this.obtenerArticulosRelacionados(item)

				if (this.TienesRelacionados){
					var cadenaSinCorchetes = this.CadenaRelacionados.replace(/\[|\]/g, '');
					var valores = cadenaSinCorchetes.split(',');
					if (valores.length > 1) {
						this.$root.$emit('Layout-Buscar',  { buscar: this.CadenaRelacionados, pagina: 1, busquedaAvanzada: false } )
					}else{
						if (item.url != '') {
							location.href = item.url;
						}
					}
				}
				else
				{
					//Si no tiene relacionados abre el url del articulo
					if(item.url != ''){ 
						location.href = item.url
					}
				}
			},
			getImagen(imagen) {
				let imagenes = require.context("@/assets/img-priv/", false)				
				return imagenes("./" + imagen + ".png")
			},
			publicidadBannersChicos(){
				return  [
						{'idBanner':0}//'@' + process.env.BASE_URL + '/assets/img-priv/Banner-Plantilla-mediano-1.png',
						// {'url': this.getImagen('Banner-Plantilla-mediano-2'),//'@' + process.env.BASE_URL + '/assets/img-priv/Banner-Plantilla-mediano-2.png',
						// 'idBanner':2}
					]
			},
			publicidadBannersMedianos(){
				return  [
						{'idBanner':0}//'@' + process.env.BASE_URL + '/assets/img-priv/Banner-Plantilla-mediano-1.png',
						
						// {'url': this.getImagen('Banner-Plantilla-mediano-2'),//'@' + process.env.BASE_URL + '/assets/img-priv/Banner-Plantilla-mediano-2.png',
						// 'idBanner':2}
					]
			},
			publicidadBannersGrandes(){
				return  [
						{'idBanner':0}//'@' + process.env.BASE_URL + '/assets/img-priv/Banner-Plantilla-mediano-1.png',
						// {'url': this.getImagen('Banner-Plantilla-GRANDE-2'),//'@' + process.env.BASE_URL + '/assets/img-priv/Banner-Plantilla-mediano-2.png',
						// 'idBanner':2}
					]
			},
			registrarClickPublicidad(item){
				let token = undefined;
				let codCliente = undefined;
				if(window.localStorage.tokenDifarmer){
					let lsToken= JSON.parse(window.localStorage.tokenDifarmer)
					token = lsToken.token

					let lsUser = JSON.parse(lsToken.user);
					codCliente = lsUser.codCliente;
				}
				
				servicio.registrarClickPublicidad({
					IdPublicidad: item.idBannersImagen,
					TipoPublicidad: "B",
					CodCliente: codCliente,
					AccessToken: token
				})
				.then((response => {
					
					if(response.value){
						console.log("Se registro click publicidad")
					}
				}) )
				.catch(error => {
					console.error(error);
				})
			},
			async obtenerArticulosRelacionados(item){
				this.TienesRelacionados = false
				this.CadenaRelacionados = ""

				let r = await servicio.obtenerArticulosRelacionados(item.idBannersImagen,"B")
				console.log(r)
				if (r.value){
					this.CadenaRelacionados = r.data[0]
					this.TienesRelacionados = true
				}
				// .then((response => {
					
				// 	if(response.value){
				// 		if(response.data[0] != ""){
				// 			this.CadenaRelacionados = response.data[0]
				// 			this.TienesRelacionados = true
				// 			return true
				// 		}
				// 		else{
				// 			return false
				// 		}
				// 	}else{
				// 		return false
				// 	}
				// }) )
				// .catch(error => {
				// 	console.error(error);
				// 	return false
				// })
			}
		},
		computed: {
			tipo1() {
				//return this.items.filter(item => item.tipo == 1)
				let itemsRegresa = this.items.filter(item => item.tipo == 1)
				if(itemsRegresa.length > 0){
					itemsRegresa = this.items.filter(item => item.tipo == 1)
				}
				else{
					if(this.items.length > 0){
						itemsRegresa = this.publicidadBannersGrandes()
					}
				}
				return itemsRegresa
			},
			tipo2() {
				//return this.items.filter(item => item.tipo == 2)
				let itemsRegresa = this.items.filter(item => item.tipo == 2)
				if(itemsRegresa.length > 0){
					itemsRegresa = this.items.filter(item => item.tipo == 2)
				}
				else{
					if(this.items.length > 0){
						itemsRegresa = this.publicidadBannersMedianos()
					}
				}
				return itemsRegresa
			},
			tipo3() {
				//return this.items.filter(item => item.tipo == 3)
				let itemsRegresa = this.items.filter(item => item.tipo == 3)
				if(itemsRegresa.length > 0){
					itemsRegresa = this.items.filter(item => item.tipo == 3)
				}
				else{
					if(this.items.length > 0){
						itemsRegresa = this.publicidadBannersMedianos()
					}
				}
				return itemsRegresa
			},
			tipo4() {
				//return this.items.filter(item => item.tipo == 4)
				let itemsRegresa = this.items.filter(item => item.tipo == 4)
				if(itemsRegresa.length > 0){
					itemsRegresa = this.items.filter(item => item.tipo == 4)
				}
				else{
					if(this.items.length > 0){
						itemsRegresa = this.publicidadBannersMedianos()
					}
				}
				return itemsRegresa
			},
			tipo5() {
				//return this.items.filter(item => item.tipo == 5)
				let itemsRegresa = this.items.filter(item => item.tipo == 5)
				if(itemsRegresa.length > 0){
					itemsRegresa = this.items.filter(item => item.tipo == 5)
				}
				else{
					if(this.items.length > 0){
						itemsRegresa = this.publicidadBannersMedianos()
					}
				}
				return itemsRegresa
			},
			tipo6() {
				let itemsRegresa = this.items.filter(item => item.tipo == 6)
				if(itemsRegresa.length > 0){
					itemsRegresa = this.items.filter(item => item.tipo == 6)
				}
				else{
					if(this.items.length > 0){

						itemsRegresa = this.publicidadBannersChicos()
					}
				}				
				return itemsRegresa
			}
		}
	}
</script>

<style>
</style>
